import { inject } from '@angular/core';
import { TaskRepository } from '../../service/task/task-repository';
import { Task } from '../../model/task/task.model';

export class GetTasksUseCase {
  constructor(
    private taskRepository: TaskRepository = inject(TaskRepository)
  ) {}

  execute(): Promise<Task[]> {
    return this.taskRepository.getTasks();
  }

  addTask(title: string): Promise<Task> {
    return this.taskRepository.addTask(title);
  }

  removeTask(id: string): Promise<void> {
    return this.taskRepository.removeTask(id);
  }

  toggleTask(id: string): Promise<Task> {
    return this.taskRepository.toggleTask(id);
  }
}
